import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  display: flex;
  margin: 15px 0;
  position: relative;
`;

export const Avatar = styled.div`
  width: 130px;
  overflow: hidden;

  ${mediaMaxWidth.smallPhone} {
    width: 120px;
  }
`;

export const AvatarImg = styled.img`
  width: 110px;
  height: 110px;
  border-radius: 4px;
  object-fit: cover;

  ${mediaMaxWidth.smallPhone} {
    width: 90px;
    height: 90px;
  }
`;

export const About = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;
  top: 3px;
  height: 105px;

  ${mediaMaxWidth.tablet} {
    left: 130px;
    position: absolute;
    top: 2px;
  }

  ${mediaMaxWidth.smallPhone} {
    height: 90px;
    left: 120px;
    top: 0;
  }
`;

interface ILineProps {
  name?: boolean;
}

export const Line = styled.div`
  font-size: 0.85em;
  font-weight: ${(props: ILineProps) => props.name && "700"};
  width: 750px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMaxWidth.smallDesktop} {
    width: 450px;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 195px);
  }

  ${mediaMaxWidth.smallPhone} {
    width: calc(100vw - 165px);
    font-size: 0.8em;
  }
`;

export const LineLink = styled.a`
  text-decoration: underline !important;
  color: #333 !important;
  cursor: pointer;

  svg {
    margin-right: 10px;
    font-size: 0.9em;
  }

  &:hover {
    color: #f2008c !important;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 85px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ContactButton = styled.div`
  font-size: 0.85em;
  cursor: pointer;
  position: absolute;
  bottom: 0;
  text-decoration: underline;

  ${mediaMaxWidth.smallPhone} {
    width: calc(100vw - 165px);
    font-size: 0.75em;
  }
`;
